module.exports = __webpack_public_path__ + "img/ic_benifit_book.59f0185e.png";